import React from 'react';
import { StyledLogo, StyledLogoProps } from './Logo.styled';

export const LogoMedium = (props: StyledLogoProps) => (
  <StyledLogo viewBox="0 0 107 31" width={107} height={31} {...props}>
    <defs>
      <path id="a" d="M0 0h16.86v8.43H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M48.518 30.124h4.599V11.73h-4.599zM40.854 30.124h4.598V11.73h-4.598zM33.19 30.124h4.598V11.73H33.19zM76.876 11.73v4.598a4.603 4.603 0 0 1 4.598 4.599h4.599a9.197 9.197 0 0 0-9.197-9.197M36.255 1v4.599a4.603 4.603 0 0 1 4.599 4.598h4.599A9.197 9.197 0 0 0 36.255 1"
      />
      <path
        fill="currentColor"
        d="M37.788 20.927h-4.599a4.603 4.603 0 0 1-4.599 4.599v4.598a9.197 9.197 0 0 0 9.198-9.197M96.803 30.124v-4.598a4.603 4.603 0 0 1-4.599-4.599h-4.598a9.197 9.197 0 0 0 9.197 9.197"
      />
      <path
        fill="currentColor"
        d="M56.949 11.73a8.43 8.43 0 0 0-8.431 8.43v.767h4.598v-.766a3.836 3.836 0 0 1 3.833-3.833 3.836 3.836 0 0 1 3.832 3.833v9.963h4.598v-9.963a8.43 8.43 0 0 0-8.43-8.431"
      />
      <path
        fill="currentColor"
        d="M9.43 3.3a7.28 7.28 0 1 0 0 14.561v-4.598a2.685 2.685 0 0 1-2.683-2.683A2.685 2.685 0 0 1 9.43 7.898a2.685 2.685 0 0 1 2.682 2.682h4.599A7.28 7.28 0 0 0 9.43 3.3"
      />
      <path
        fill="currentColor"
        d="M13.262 21.693h4.598a8.43 8.43 0 0 0-8.43-8.43v4.598a3.836 3.836 0 0 1 3.832 3.832"
      />
      <path
        fill="currentColor"
        d="M9.43 17.861v-4.598a2.685 2.685 0 0 1-2.683-2.683H2.148a7.28 7.28 0 0 0 7.282 7.281"
      />
      <g transform="translate(1 21.693)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="currentColor"
          d="M8.43 3.832A3.835 3.835 0 0 1 4.6.024H0A8.43 8.43 0 0 0 16.86 0h-4.598A3.836 3.836 0 0 1 8.43 3.832"
          mask="url(#b)"
        />
      </g>
      <path
        fill="currentColor"
        d="M28.59 25.526a4.604 4.604 0 0 1-4.598-4.599 4.604 4.604 0 0 1 4.598-4.599 4.603 4.603 0 0 1 4.599 4.599h4.598a9.197 9.197 0 1 0-9.197 9.197v-4.598zM76.876 25.526a4.603 4.603 0 0 1-4.599-4.599 4.603 4.603 0 0 1 4.599-4.599V11.73a9.197 9.197 0 1 0 9.197 9.197h-4.599a4.603 4.603 0 0 1-4.598 4.599M96.803 11.73a9.197 9.197 0 0 0-9.197 9.197h4.598a4.603 4.603 0 0 1 4.599-4.599 4.603 4.603 0 0 1 4.598 4.599 4.603 4.603 0 0 1-4.598 4.599v4.598a9.197 9.197 0 0 0 0-18.394"
      />
    </g>
  </StyledLogo>
);
